import React from 'react';
import {
  Box, Button, CardHeader, Divider,
  Grid, InputLabel,
  MenuItem,
  Paper,
  Table, TableBody, TableCell,
  TableContainer,
  TableHead, TableRow,
  TextField
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DeleteIcon from '@material-ui/icons/Delete';
import { useEffect, useState, } from 'react';
import { useAlert } from "react-alert";
import { trackPromise } from 'react-promise-tracker';
import { MaskeliyaBLERPEnum } from '../../../Common//MaskeliyaBLERPEnum/MaskeliyaBLERPEnum';
import services from '../../Services';
import { ref } from 'yup';

export default function Grading({ handleBack, factoryData, setIsGrading, firingDetails, arrayField, setArrayField, gradeDetails, setFiringDetails, setGradeDetails, StatusID, manufacturingDetail }) {
  const maskeliyaBLERPEnum = new MaskeliyaBLERPEnum()
  const [gradingDetails, setGradingDetails] = useState({
    gradeCategoryID: "0",
    gradeID: 0,
    gradingAmount: 0,
    purchaseDate: ''
  });
  const [mainGradeList, setMainGradeList] = useState([]);
  const [gradeList, setGradeList] = useState([]);
  const [deleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  const [indexToDelete, setIndexToDelete] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [formTouched, setFormTouched] = useState({});

  const alert = useAlert();

  useEffect(() => {
    trackPromise(
      GetAllGradeCategory()
    );
  }, []);

  useEffect(() => {
    trackPromise(
      GetGradeByGradeCategoryID()
    );
  }, [gradingDetails.gradeCategoryID]);

  useEffect(() => {
    setGradeDetails((prevState) => ({
      ...prevState,
      refusePercentage: parseFloat((gradeDetails.refuseAmount / firingDetails.fireWeight) * 100).toFixed(1)
    }));
  }, [gradeDetails.refuseAmount, firingDetails.totalFireWeight]);

  useEffect(() => {
    setGradingDetails((prevState) => ({
      ...prevState,
      purchaseDate: manufacturingDetail.toDateOfManufacture
    }));
  }, [manufacturingDetail.toDateOfManufacture]);

  useEffect(() => {
    const totalGrading = arrayField.reduce((accumulator, current) => accumulator + current.gradingAmount, 0) || 0;
    const remainingAmtVal = Math.max(0, firingDetails.fireWeight - totalGrading - (parseFloat(gradeDetails.refuseAmount) || 0));

    setGradeDetails((prevState) => ({
      ...prevState,
      remainingAmount: parseFloat(remainingAmtVal).toFixed(2),
      netOutTurn: parseFloat((totalGrading / manufacturingDetail.greenLeafAmount) * 100),
    }));

    if (arrayField.length === 0) {
      setIsGrading(false);
    } else {
      setIsGrading(true);
    }

    if ((firingDetails.fireWeight - totalGrading) < gradeDetails.refuseAmount) {
      setFiringDetails((prevState) => ({
        ...prevState,
        moistureGain: parseFloat(gradeDetails.refuseAmount - (firingDetails.fireWeight - totalGrading)).toFixed(2)
      }));
    } else {
      setFiringDetails((prevState) => ({
        ...prevState,
        moistureGain: parseFloat(0.00).toFixed(2)
      }));
    }

  }, [arrayField, firingDetails.fireWeight, manufacturingDetail.greenLeafAmount, gradeDetails.refuseAmount]);

  useEffect(() => {
    if (mainGradeList.length > 0 && gradingDetails.gradeCategoryID === 0) {
      setGradingDetails((prevState) => ({
        ...prevState,
        gradeCategoryID: mainGradeList[0].skuCategoryID,
      }));
    }
  }, [mainGradeList]);

  const validateForm = () => {
    const errors = {};
    if (!gradingDetails.gradeCategoryID || gradingDetails.gradeCategoryID === 0) {
      errors.gradeCategoryID = 'Grade Category is required';
    }

    if (!gradingDetails.gradeID || gradingDetails.gradeID === 0) {
      errors.gradeID = 'Grade is required';
    }

    if (!gradingDetails.gradingAmount || parseFloat(gradingDetails.gradingAmount) <= 0) {
      errors.gradingAmount = 'Grading Amount should be greater than 0';
    } else if (parseFloat(gradingDetails.gradingAmount) > (firingDetails.fireWeight - (arrayField.reduce((acc, curr) => acc + curr.gradingAmount, 0) || 0))) {
      errors.gradingAmount = 'Grading Amount should be less than Total Firing Weight';
    }

    if (!gradingDetails.purchaseDate) {
      errors.purchaseDate = 'Grading Date is required';
    }

    return errors;
  };

  async function GetAllGradeCategory() {
    const details = await services.GetAllGradeCategory();
    setMainGradeList(details);
  }

  async function GetGradeByGradeCategoryID() {
    const details = await services.GetGradeByGradeCategoryID(gradingDetails.gradeCategoryID);
    setGradeList(details)
  }

  function handleChange(e) {
    const { name, value } = e.target;
    setGradingDetails({
      ...gradingDetails,
      [name]: value
    });

    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: undefined
      });
    }

    setFormTouched({
      ...formTouched,
      [name]: true
    });
  }

  function handleBlur(e) {
    const { name } = e.target;
    setFormTouched({
      ...formTouched,
      [name]: true
    });

    const validationErrors = validateForm();
    if (validationErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: validationErrors[name]
      });
    }
  }

  function handleChangeRefuse(e) {
    const target = e.target;
    const value = target.value;
    const finalValue = value === "" ? parseFloat(0) : value;
    var reg = new RegExp('^[0-9]{0,9}([.]?[0-9]{0,2})?$');
    if (reg.test(finalValue) === false) {
      return;
    }
    setGradeDetails({
      ...gradeDetails,
      [e.target.name]: finalValue === "" ? parseFloat(0) : parseFloat(finalValue)
    });
  }

  async function handleConfirmDelete() {
    setDeleteConfirmationOpen(false);
    if (indexToDelete !== null) {
      const dataDelete = [...arrayField];
      dataDelete.splice(indexToDelete, 1);
      setArrayField([...dataDelete]);
      setIndexToDelete(null);
    }
  }

  async function handleClickDelete(rowData, index) {
    setIndexToDelete(index);
    setDeleteConfirmationOpen(true);
  }

  const handleCancelDelete = () => {
    setDeleteConfirmationOpen(false);
    setIndexToDelete(null);
  };

  function AddFieldData(event) {
    if (event) event.preventDefault();

    const errors = validateForm();
    setFormErrors(errors);
    setFormTouched({
      gradeCategoryID: true,
      gradeID: true,
      gradingAmount: true,
      purchaseDate: true
    });

    if (Object.keys(errors).length > 0) {
      return;
    }

    const newModel = {
      gradeCategoryID: parseInt(gradingDetails.gradeCategoryID),
      gradeCategoryName: mainGradeList?.find(x => x.skuCategoryID === parseInt(gradingDetails.gradeCategoryID))?.skuCategoryName,
      gradeID: parseInt(gradingDetails.gradeID),
      gradeName: gradeList?.find(x => x.skuMasterID === parseInt(gradingDetails.gradeID))?.skuMasterName,
      gradingAmount: parseFloat(gradingDetails.gradingAmount),
      purchaseDate: gradingDetails.purchaseDate
    };

    const isDuplicate = arrayField.some(
      (row) =>
        row.gradeCategoryID === newModel.gradeCategoryID &&
        row.gradeID === newModel.gradeID
    );

    if (isDuplicate) {
      alert.error('Cannot Add Duplicate Grade');
      return;
    }

    setArrayField([...arrayField, newModel]);
    alert.success('Row Updated');

    setGradingDetails((prevState) => ({
      ...prevState,
      gradeID: 0,
      gradingAmount: 0,
      purchaseDate: gradingDetails.purchaseDate
    }));
  }

  const onKeyDown = (e) => {
    e.preventDefault();
  };

  return (
    <>
      <div> {/* Changed from <form> to <div> to avoid nesting forms */}
        <CardHeader title={"Grading"} />
        <Divider />
        &nbsp;
        <Grid container spacing={3}>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="dhoolWeight">
              Total Firing Weight (KG)
            </InputLabel>
            <TextField
              fullWidth
              name="dhoolWeight"
              variant="outlined"
              id="dhoolWeight"
              size="small"
              value={firingDetails.fireWeight}
              InputProps={{
                readOnly: true,
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            />
          </Grid>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="gradeCategoryID">
              Grade Category *
            </InputLabel>
            <TextField select
              fullWidth
              error={Boolean(formTouched.gradeCategoryID && formErrors.gradeCategoryID)}
              helperText={formTouched.gradeCategoryID && formErrors.gradeCategoryID}
              name="gradeCategoryID"
              onBlur={handleBlur}
              onChange={handleChange}
              value={gradingDetails.gradeCategoryID}
              size='small'
              variant="outlined"
              id="gradeCategoryID"
              disabled={StatusID == 2 || StatusID == 3}
            >
              <MenuItem value="0">--Select Grade Category--</MenuItem>
              {mainGradeList.map((item) =>
                <MenuItem key={item.skuCategoryID} value={item.skuCategoryID}>
                  {item.skuCategoryName}
                </MenuItem>
              )}
            </TextField>
          </Grid>

          <Grid item md={3} xs={12}>
            <InputLabel shrink id="gradeID">
              Grade *
            </InputLabel>
            <TextField
              select
              fullWidth
              error={Boolean(formTouched.gradeID && formErrors.gradeID)}
              helperText={formTouched.gradeID && formErrors.gradeID}
              name="gradeID"
              onBlur={handleBlur}
              onChange={handleChange}
              value={gradingDetails.gradeID}
              variant="outlined"
              size='small'
              id="gradeID"
              disabled={StatusID == 2 || StatusID == 3}
            >
              <MenuItem value="0">--Select Grade--</MenuItem>
              {gradeList.map((item) =>
                <MenuItem key={item.skuMasterID} value={item.skuMasterID}>
                  {item.skuMasterName}
                </MenuItem>
              )}
            </TextField>
          </Grid>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="gradingAmount">
              Grading Amount (KG) *
            </InputLabel>
            <TextField
              error={Boolean(formTouched.gradingAmount && formErrors.gradingAmount)}
              fullWidth
              helperText={formTouched.gradingAmount && formErrors.gradingAmount}
              name="gradingAmount"
              onBlur={handleBlur}
              onChange={handleChange}
              value={gradingDetails.gradingAmount}
              size='small'
              variant="outlined"
              id="gradingAmount"
              inputProps={{
                max: firingDetails.fireWeight
              }}
              disabled={StatusID == 2 || StatusID == 3}
              InputProps={{
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            >
            </TextField>
          </Grid>
        </Grid>
        <Grid container spacing={3}>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="purchaseDate">
              Grading Date *
            </InputLabel>
            <TextField
              fullWidth
              type="date"
              error={Boolean(formTouched.purchaseDate && formErrors.purchaseDate)}
              helperText={formTouched.purchaseDate && formErrors.purchaseDate}
              InputLabelProps={{
                shrink: true,
              }}
              name="purchaseDate"
              onBlur={handleBlur}
              onChange={handleChange}
              value={gradingDetails.purchaseDate}
              variant="outlined"
              id="purchaseDate"
              size='small'
              disabled={StatusID == 2 || StatusID == 3}
              inputProps={{
                min: firingDetails.endDateTime?.split('T')[0],
                max: manufacturingDetail.toDateOfManufacture
              }}
              onKeyDown={onKeyDown}
            >
            </TextField>
          </Grid>
        </Grid>
        &nbsp;
        {StatusID == 0 || StatusID == 1 ?
          <Box display="flex" justifyContent="flex-end">
            <Button
              color="primary"
              variant="contained"
              onClick={AddFieldData}
              size='small'
            >
              Add
            </Button>
          </Box> : null}
        &nbsp;

        {(arrayField.length > 0) ?
          <TableContainer component={Paper} elevation={3} sx={{ borderRadius: 2, overflow: 'hidden' }}>
            <Table size='small' aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell align='left'>Grade Category</TableCell>
                  <TableCell align='left'>Grade</TableCell>
                  <TableCell align='right'>Grading Amount</TableCell>
                  <TableCell align='left'>Grading Date</TableCell>
                  {StatusID == 0 || StatusID == 1 ?
                    <TableCell align='center'>Actions</TableCell> : null}
                </TableRow>
              </TableHead>
              <TableBody>
                {arrayField.map((rowData, index) => (
                  <TableRow key={index}>
                    <TableCell align='left' component="th" scope="row" style={{ borderBottom: "none" }}>
                      {rowData.gradeCategoryName}
                    </TableCell>
                    <TableCell align='left' component="th" scope="row" style={{ borderBottom: "none" }}>
                      {rowData.gradeName}
                    </TableCell>
                    <TableCell align='right' component="th" scope="row" style={{ borderBottom: "none" }}>
                      {parseFloat(rowData.gradingAmount).toLocaleString(undefined, { minimumFractionDigits: 2 })}
                    </TableCell>
                    <TableCell align='left' component="th" scope="row" style={{ borderBottom: "none" }}>
                      {rowData.purchaseDate.split('T')[0]}
                    </TableCell>
                    <TableCell align='center' scope="row" style={{ borderBottom: "none" }}>
                      {StatusID == 0 || StatusID == 1 ?
                        <DeleteIcon
                          style={{
                            color: "red",
                            cursor: "pointer"
                          }}
                          size="small"
                          onClick={() => handleClickDelete(rowData, index)}
                        >
                        </DeleteIcon> : null}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer> : null}
        &nbsp;

        <Grid container spacing={3}>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="netOutTurn">
              Net Outturn (%)
            </InputLabel>
            <TextField
              fullWidth
              name="netOutTurn"
              value={parseFloat((arrayField.reduce((accumulator, current) => accumulator + current.gradingAmount, 0) / manufacturingDetail.greenLeafAmount) * 100).toFixed(1)}
              size='small'
              variant="outlined"
              id="netOutTurn"
              InputProps={{
                readOnly: true,
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            >
            </TextField>
          </Grid>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="remainingAmount">
              Remaining Amount
            </InputLabel>
            <TextField
              fullWidth
              name="remainingAmount"
              value={gradeDetails.remainingAmount}
              size='small'
              variant="outlined"
              id="remainingAmount"
              InputProps={{
                readOnly: true,
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            >
            </TextField>
          </Grid>
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="refuseAmount">
              Refuse Amount
            </InputLabel>
            <TextField
              fullWidth
              name="refuseAmount"
              onBlur={handleBlur}
              onChange={handleChangeRefuse}
              value={gradeDetails.refuseAmount}
              size='small'
              variant="outlined"
              id="refuseAmount"
              InputProps={{
                readOnly: StatusID == 2 || StatusID == 3,
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            >
            </TextField>
          </Grid>
          {/* <Grid item md={3} xs={8}>
            <InputLabel shrink id="moistureGain">
              Moisture Gain
            </InputLabel>
            <TextField
              fullWidth
              name="moistureGain"
              value={firingDetails.moistureGain}
              variant="outlined"
              id="moistureGain"
              size='small'
              InputProps={{
                readOnly: true,
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            >
            </TextField>
          </Grid> */}
          <Grid item md={3} xs={8}>
            <InputLabel shrink id="refusePercentage">
              Refuse (%)
            </InputLabel>
            <TextField
              fullWidth
              name="refusePercentage"
              value={gradeDetails.refusePercentage}
              size='small'
              variant="outlined"
              id="refusePercentage"
              InputProps={{
                readOnly: true,
                inputProps: {
                  step: 0.01,
                  type: 'number',
                  style: {
                    textAlign: 'right',
                  },
                },
              }}
              onKeyDown={(evt) =>
                (evt.key === "-") && evt.preventDefault()
              }
              onWheel={event => event.target.blur()}
            >
            </TextField>
          </Grid>
        </Grid>
        &nbsp;
        <Box display="flex" justifyContent="flex-end">
          <Button
            color="primary"
            variant="contained"
            type='button'
            size='small'
            onClick={handleBack}
          >
            Back
          </Button>
        </Box>
        <Dialog open={deleteConfirmationOpen} onClose={handleCancelDelete}>
          <DialogTitle>Delete Confirmation</DialogTitle>
          <DialogContent>
            <p>Are you sure, you want to delete this record?</p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleConfirmDelete} color="primary">
              Delete
            </Button>
            <Button
              onClick={handleCancelDelete} color="primary">
              Cancel
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  )
}
